<div class="condition-group d-flex flex-column">
  <span class="label">{{ label }}</span>
  @if (items.length === 0) {
    <div class="no-items">None selected</div>
  }
  @if (items.length > 0) {
    <div class="d-flex flex-wrap" style="gap: 8px">
      @for (item of items; let index = $index; track index) {
        <span class="condition">
          {{ item }}
        </span>
      }
    </div>
  }
</div>
